// /* eslint-disable jsx-a11y/click-events-have-key-events */
// /* eslint-disable jsx-a11y/no-static-element-interactions */
// import React, { useMemo } from 'react';
// import { Badge } from 'reactstrap';
// import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';
// import ActionsFormatter from 'components/ActionsFormatter';
// import './KanbanView.css';

// const KanbanView = ({
//   orders,
//   onClickEdit,
//   handleViewDetail,
//   handleOrderLinkClick,
//   toggleDeleteRecord,
//   filters,
//   totalCount,
//   totalPages,
//   handlePageChange,
// }) => {
//   // All possible status columns with their configurations
//   const allStatusColumns = {
//     PENDING: { title: 'Pending', orders: [], color: '#6c757d' },
//     IN_PROGRESS: { title: 'In_Progress', orders: [], color: '#00bcd4' },
//     LOADING: { title: 'Loading', orders: [], color: '#ffc107' },
//     DISPATCHED: { title: 'Dispatched', orders: [], color: '#2196f3' },
//     DELIVERED: { title: 'Delivered', orders: [], color: '#4caf50' },
//   };

//   // Dynamically group orders by status and filter out empty columns
//   const statusColumns = useMemo(() => {
//     const columns = { ...allStatusColumns };

//     // Group orders by their status
//     orders.forEach((order) => {
//       const status = order.status;
//       if (columns[status]) {
//         columns[status].orders.push(order);
//       }
//     });

//     // Filter out columns with no orders
//     const activeColumns = {};
//     Object.entries(columns).forEach(([key, value]) => {
//       if (value.orders.length > 0) {
//         activeColumns[key] = value;
//       }
//     });

//     return activeColumns;
//   }, [orders]);

//   const getPaymentStatusBadgeClass = (status) => {
//     switch (status) {
//       case 'FULLY_PAID':
//         return 'success';
//       case 'PARTIALLY_PAID':
//         return 'warning';
//       default:
//         return 'danger';
//     }
//   };

//   const KanbanCard = ({ order }) => {
//     return (
//       <div className="kanban-card" onClick={() => handleViewDetail(order)}>
//         {/* Card Header with Order ID */}
//         <div className="kanban-card-header">
//           <div className="order-id-badge">#{order.id}</div>
//           <Badge color="info" className="grade-badge">
//             {order?.grade?.name || 'N/A'}
//           </Badge>
//         </div>

//         {/* Card Body */}
//         <div className="kanban-card-body">
//           {/* Seller Info */}
//           <div className="info-row">
//             <span className="info-label">Seller:</span>
//             <span className="info-value" title={order?.seller?.entityName}>
//               {order?.seller?.entityName}
//             </span>
//           </div>

//           {/* Buyer Info */}
//           <div className="info-row">
//             <span className="info-label">Buyer:</span>
//             <span className="info-value" title={order?.buyer?.entityName}>
//               {order?.buyer?.entityName}
//             </span>
//           </div>

//           {/* Location */}
//           <div className="info-row">
//             <span className="info-label">Location:</span>
//             <span className="info-value">
//               {order?.city?.cityName || order?.portOfDischarge?.name || 'N/A'}
//             </span>
//           </div>

//           {/* Rate */}
//           <div className="info-row">
//             <span className="info-label">Rate:</span>
//             <span className="info-value">
//               {currencyToLocal(order?.rate, order?.rateUnit?.isoCurrencyCode)}/
//               {order?.quantityUnit}
//             </span>
//           </div>

//           {/* Quantity Info */}
//           <div className="quantity-row">
//             <div className="quantity-item">
//               <span className="quantity-label">Ordered:</span>
//               <span className="quantity-value">
//                 {NumberWithCommasFormat(order?.quantity)}
//                 {order?.quantityUnit}
//               </span>
//             </div>
//             <div className="quantity-item">
//               <span className="quantity-label">Pending:</span>
//               <span className="quantity-value pending">
//                 {NumberWithCommasFormat(order?.pendingQuantity)}
//                 {order?.quantityUnit}
//               </span>
//             </div>
//           </div>

//           {/* Payment Status */}
//           <div className="status-row">
//             <Badge
//               color={getPaymentStatusBadgeClass(order?.paymentStatus)}
//               className="payment-badge"
//             >
//               {order?.paymentStatus?.replace('_', ' ')}
//             </Badge>
//           </div>

//           {/* Actions - Show on hover */}
//           <div
//             className="card-actions"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <ActionsFormatter
//               handleDelete={() => toggleDeleteRecord(order)}
//               handleView={() => handleOrderLinkClick(order)}
//               handleEdit={() => onClickEdit(order)}
//               isDelete={true}
//               isView={true}
//               isEdit={true}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // Show message if no orders
//   if (orders.length === 0) {
//     return (
//       <div className="kanban-container">
//         <div className="no-orders-message">
//           <i className="bi bi-inbox" style={{ fontSize: '48px', color: '#5e6c84' }}></i>
//           <h5>No orders available</h5>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="kanban-container">
//       <div className="kanban-board">
//         {Object.entries(statusColumns).map(([status, column]) => (
//           <div key={status} className="kanban-column">
//             <div
//               className="kanban-column-header"
//               style={{ backgroundColor: column.color }}
//             >
//               <h6 className="mb-0 text-white">
//                 {column.title} ({column.orders.length})
//               </h6>
//             </div>
//             <div className="kanban-column-content">
//               {column.orders.map((order) => (
//                 <KanbanCard key={order.id} order={order} />
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Pagination */}
//       {totalCount > 0 && (
//         <div className="kanban-pagination">
//           <div className="pagination-info">
//             Showing {orders.length} of {totalCount} orders
//           </div>
//           <div className="pagination-controls">
//             <button
//               className="btn btn-sm btn-outline-secondary"
//               disabled={filters.pageNo === 1}
//               onClick={() =>
//                 handlePageChange({
//                   pageNo: filters.pageNo - 1,
//                   pageSize: filters.pageSize,
//                 })
//               }
//             >
//               Previous
//             </button>
//             <span className="page-indicator">
//               Page {filters.pageNo} of {totalPages}
//             </span>
//             <button
//               className="btn btn-sm btn-outline-secondary"
//               disabled={filters.pageNo >= totalPages}
//               onClick={() =>
//                 handlePageChange({
//                   pageNo: filters.pageNo + 1,
//                   pageSize: filters.pageSize,
//                 })
//               }
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default KanbanView;

// This code is for pagination ----------------------------------------------------------------------------------------------

import React, { useRef, useCallback, useEffect } from 'react';
import { Badge } from 'reactstrap';
import { currencyToLocal, NumberWithCommasFormat } from 'utils/constants';
import ActionsFormatter from 'components/ActionsFormatter';
import './KanbanView.css';

const KanbanCard = React.memo(
  ({
    order,
    handleViewDetail,
    handleOrderLinkClick,
    toggleDeleteRecord,
    onClickEdit,
  }) => {
    const formatDateTime = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };

    const handleCardClick = () => {
      handleViewDetail(order);
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleViewDetail(order);
      }
    };

    const handleActionsClick = (e) => {
      e.stopPropagation();
    };

    return (
      <div
        className="kanban-card"
        onClick={handleCardClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        aria-label={`View details for order #${order.id}`}
      >
        <div className="kanban-card-header">
          <div className="kanban-card-title">
            <div className="order-id-badge">#{order.id}</div>
            <div className="created-datetime">
              <span>{formatDateTime(order?.createdAt)}</span>
            </div>
          </div>
          <Badge color="info" className="grade-badge">
            {order?.grade?.name || 'N/A'}
          </Badge>
        </div>

        <div className="kanban-card-body">
          <div className="info-row">
            <span className="info-label">Seller</span>
            <span className="info-value" title={order?.seller?.entityName}>
              {order?.seller?.entityName}
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Buyer</span>
            <span className="info-value" title={order?.buyer?.entityName}>
              {order?.buyer?.entityName}
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Location</span>
            <span className="info-value">
              {order?.city?.cityName || order?.portOfDischarge?.name || 'N/A'}
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Rate</span>
            <span className="info-value rate-value">
              {currencyToLocal(order?.rate, order?.rateUnit?.isoCurrencyCode)}/
              KG
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Quantity</span>
            <span className="info-value">
              {NumberWithCommasFormat(order?.pendingQuantity)}
              {order?.quantityUnit || 'MT'}/
              {NumberWithCommasFormat(order?.quantity)}
              {order?.quantityUnit || 'MT'}
            </span>
          </div>

          <div
            className="card-actions"
            onClick={handleActionsClick}
            onKeyDown={handleActionsClick}
            role="button"
            tabIndex={0}
          >
            <ActionsFormatter
              handleDelete={() => toggleDeleteRecord(order)}
              handleView={() => handleOrderLinkClick(order)}
              handleEdit={() => onClickEdit(order)}
              isDelete
              isView
              isEdit
            />
          </div>
        </div>
      </div>
    );
  },
);

KanbanCard.displayName = 'KanbanCard';

const allStatusColumns = {
  PENDING: { title: 'Pending', color: '#6c757d' },
  IN_PROGRESS: { title: 'In Progress', color: '#00bcd4' },
  LOADING: { title: 'Loading', color: '#ff9800' },
  DISPATCHED: { title: 'Dispatched', color: '#2196f3' },
  DELIVERED: { title: 'Delivered', color: '#4caf50' },
  CANCELLED: { title: 'Cancelled', color: '#9e9e9e' },
  DELETED: { title: 'Deleted', color: '#f44336' },
};

const KanbanView = ({
  statusData,
  onClickEdit,
  handleViewDetail,
  handleOrderLinkClick,
  toggleDeleteRecord,
  onLoadMore,
  visibleStatuses = Object.keys(allStatusColumns),
}) => {
  // Refs for each column's scroll container
  const columnRefs = useRef({});
  const loadingRefs = useRef({});

  // Scroll handler for each column
  const handleScroll = useCallback(
    (status) => {
      const scrollContainer = columnRefs.current[status];
      if (!scrollContainer) return;

      const currentStatusData = statusData[status];

      // Prevent multiple simultaneous loads
      if (
        currentStatusData.loading ||
        !currentStatusData.hasMore ||
        loadingRefs.current[status]
      ) {
        return;
      }

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      const scrollThreshold = 150; // Load more when 150px from bottom

      if (scrollHeight - scrollTop - clientHeight < scrollThreshold) {
        loadingRefs.current[status] = true;

        const loadPromise = onLoadMore(status);
        if (loadPromise && loadPromise.finally) {
          loadPromise.finally(() => {
            loadingRefs.current[status] = false;
          });
        } else {
          loadingRefs.current[status] = false;
        }
      }
    },
    [statusData, onLoadMore],
  );

  // Add scroll listeners to all columns
  useEffect(() => {
    const listeners = {};
    const scrollContainers = {};

    Object.keys(allStatusColumns).forEach((status) => {
      const scrollContainer = columnRefs.current[status];
      if (scrollContainer) {
        const scrollHandler = () => handleScroll(status);
        scrollContainer.addEventListener('scroll', scrollHandler);
        listeners[status] = scrollHandler;
        scrollContainers[status] = scrollContainer;
      }
    });

    // Cleanup
    return () => {
      Object.keys(listeners).forEach((status) => {
        const scrollContainer = scrollContainers[status];
        if (scrollContainer && listeners[status]) {
          scrollContainer.removeEventListener('scroll', listeners[status]);
        }
      });
    };
  }, [handleScroll]);

  return (
    <div className="kanban-container">
      <div className="kanban-board">
        {Object.entries(allStatusColumns)
          .filter(([status]) => visibleStatuses.includes(status))
          .map(([status, column]) => {
            const currentStatusData = statusData[status] || {
              orders: [],
              loading: false,
              hasMore: false,
              totalCount: 0,
            };
            const {
              orders,
              loading: isLoading,
              hasMore,
              totalCount,
            } = currentStatusData;

            return (
              <div
                key={status}
                className="kanban-column"
                style={{ '--kanban-status-color': column.color }}
              >
                <div className="kanban-column-header">
                  <div className="kanban-column-title">
                    <h6 className="mb-0">{column.title}</h6>
                    <span className="kanban-count-badge">
                      {NumberWithCommasFormat(totalCount)}
                    </span>
                  </div>
                </div>
                <div
                  className="kanban-column-content"
                  ref={(el) => {
                    columnRefs.current[status] = el;
                  }}
                >
                  {orders.length > 0 ? (
                    <>
                      {orders.map((order) => (
                        <KanbanCard
                          key={order.id}
                          order={order}
                          handleViewDetail={handleViewDetail}
                          handleOrderLinkClick={handleOrderLinkClick}
                          toggleDeleteRecord={toggleDeleteRecord}
                          onClickEdit={onClickEdit}
                        />
                      ))}
                      {/* Loading indicator at bottom of each column */}
                      {isLoading && (
                        <div className="column-loading">
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                          <span className="ml-2">Loading more...</span>
                        </div>
                      )}
                      {/* No more data indicator */}
                      {!hasMore && orders.length > 0 && (
                        <div className="column-no-more">
                          <p>No more orders</p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="empty-column-message">
                      <i className="bi bi-truck" />
                      <p>No orders currently {column.title.toLowerCase()}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default KanbanView;
